import React, { useEffect, useRef, useState } from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Card, Col, FormGroup, Row } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import CompanyDetails from '../DetailFolder/CompanyDetails';
import { usePOTemplateOrderState } from '../AddPOTemplateProvider';

function CompanyTable({ element, eleIndex, dropLocation, fromForm }) {
  const cardRef = useRef(null);
  const { t } = useTranslation('common');
  const [companyData, setCompanyData] = useState(null);
  const { deleteCard, modfiyReqAndEnable, changeLabel } = usePOTemplateOrderState();
  useEffect(() => {
    if (!isEmpty(element)) {
      setCompanyData({ ...element });
    }
  }, [element]);

  const [{ itemDragging }] = useDrag({
    type: 'container',
    collect: (monitor) => ({
      itemDragging: monitor.getItem(),
    }),
  });

  const [{ cardOver, item }, drop] = useDrop({
    accept: 'container',
    drop: () => {
      dropLocation(eleIndex, item);
    },
    collect: (monitor) => ({
      item: monitor.getItem(),
      cardOver: monitor.isOver(),
    }),
  });

  drop(cardRef);

  const onChangeComp = (value, label, i, _eleIndex, index) => {
    const template = [...companyData.columns];
    if (template[index][i].options) {
      const updatedOptions = template[index][i].options.map((e) => {
        if (e.name === label) {
          return { ...e, value };
        }
        return e;
      });
      template[index][i].options = updatedOptions;
    } else {
      template[index][i].value = value;
    }
    setCompanyData((previosState) => ({
      ...previosState,
      columns: template,
    }));
  };

  const changePosition = (item, index, i) => {
    const dragedItem = item?.col;
    const newColumns = companyData?.columns;
    newColumns[index].splice(i, 0, dragedItem);
    if (newColumns[item?.index][item?.i]?.id === newColumns[index][i]?.id) {
      newColumns[item?.index].splice(item?.i, 1);
    } else {
      newColumns[item?.index].splice(item?.i + 1, 1);
    }

    setCompanyData((previousData) => ({
      ...previousData,
      columns: newColumns,
    }));
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <div ref={cardRef}>
        {cardOver && <div className="potemplate-drag-placeholder">{t('COMPANY_DETAILS.DROP_SECTION')}</div>}
        <Card className="listing-card">
          <Card.Header className="px-2 py-2 bgcolor-dark d-flex">
            <strong onClick={() => changeLabel(companyData, eleIndex)}>{companyData?.label}</strong>
            {itemDragging?.type !== 'container' && (
              <>
                <button
                  className="btn btn-border ml-auto py-0 px-1"
                  name="edit"
                  aria-label="Edit"
                  type="button"
                  key={`${element?.key}_${eleIndex}_edit`}
                  onClick={() => modfiyReqAndEnable(companyData, eleIndex)}
                >
                  <span className="icon-edit" />
                </button>
                <button
                  className="btn btn-border py-0 px-1"
                  aria-label="Delete"
                  key={`${element?.key}_${eleIndex}_delete`}
                  type="button"
                  onClick={() => deleteCard(eleIndex)}
                >
                  <span className="icon-delete" />
                </button>
              </>
            )}
          </Card.Header>
          {itemDragging?.type !== 'container' && (
            <Card.Body className="py-4">
              <Row className="span_font_size">
                {companyData?.columns?.map((column, index) => {
                  return (
                    <Col lg={6} key={column?.id}>
                      {column?.map((col, i) => {
                        return (
                          <FormGroup key={col?.key}>
                            <CompanyDetails
                              col={col}
                              index={index}
                              i={i}
                              onChange={onChangeComp}
                              eleIndex={eleIndex}
                              dropLocation={dropLocation}
                              changePosition={changePosition}
                              companyData={companyData}
                              fromForm={fromForm}
                            />
                          </FormGroup>
                        );
                      })}
                    </Col>
                  );
                })}
              </Row>
            </Card.Body>
          )}
        </Card>
      </div>
    </DndProvider>
  );
}

export default CompanyTable;
